import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import * as actions from '../../actions';
import { fetchWithJson } from '../../utils/api';
import ProfileList from "../../components/ProfileList/index";
import LoadSpinner from "../../components/LoadSpinner/index";
import tiaraClickSender from "../../utils/tiaraClickSender";

export class ProfileCategoryPage extends Component {
  constructor(props) {
    super(props);
    this.handleOnClickTab = this.handleOnClickTab.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.fetchProfiles = this.fetchProfiles.bind(this);
    this.state = {
      tab: "recommend",
      profiles: Immutable.List(),
      currentPage: 1,
      hasNext: true,
      isFetching: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.fetchProfiles();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const container = ReactDOM.findDOMNode(this);
    if (window.pageYOffset + window.innerHeight >= container.offsetHeight + container.offsetTop) {
      this.fetchProfiles();
    }
  }
  
  handleOnClickTab(e, name) {
    if (e) {
      e.preventDefault();
    }
    if (this.state.tab !== name) {
      this.setState({ tab: name, profiles: Immutable.List(), currentPage: 1, hasNext: true }, ()=> {
        this.fetchProfiles();
      });  
    }
  }
  
  fetchProfiles() {
    const { category } = this.props;
    const { profiles, currentPage, hasNext, isFetching } = this.state;
    const categoryId = category.get('id');
    const limitCount = category.get('limit') || true;
    if (!hasNext || isFetching) {
      return;
    }

    const url = `/api/portal/profiles/categories/${categoryId}`;
    const apiType = this.state.tab === 'rise' ? 'rise' : 'category';
    
    this.setState({ isFetching: true });
    fetchWithJson(`${url}?type=${apiType}&page=${currentPage}`).then(result => {
      const items = result.items;
      const mergedProfiles = profiles.concat(Immutable.fromJS(items));
      const hasNext = limitCount && mergedProfiles.size >= 300 ? false : result.hasNext;
      if (items) {
        this.setState({
          profiles: mergedProfiles,
          isFetching: false,
          hasNext,
          currentPage: currentPage + 1
        });
      } else {
        this.setState({
          hasNext: false,
          isFetching: false
        });
      }
    }).catch(e => {
      console.error(e.stack);
      this.setState({
        hasNext: false,
        isFetching: false
      });
    });
  }

  render() {
    const { device, location: { pathname } } = this.props;
    const { tab, profiles, isFetching } = this.state;
    return (
      <div>
        <header id="kakaoHead">
          <h1 className="screen_out">카카오톡 채널</h1>
        </header>
        <hr className="hide" />
        <main id="kakaoContent">
          <article id="mArticle">
            <h2 className="screen_out">카테고리 상세</h2>
            <ul className="tab_plus" role="tablist">
              <li className={tab === 'recommend' ? 'on' : ''}>
                <a 
                  className="link_tab" role="tab" href="#recommend"
                  onClick={(e) => {this.handleOnClickTab(e, 'recommend'); }}
                  aria-selected={tab === 'recommend' ? 'true' : 'false'}
                  data-tiara-click_url={`${pathname}?type=recommend`}
                >
                  추천
                </a>
              </li>
              <li className={tab === 'rise' ? 'on' : ''}>
                <a 
                  className="link_tab" role="tab" href="#rise"
                  onClick={(e) => {this.handleOnClickTab(e, 'rise'); }}
                  aria-selected={tab === 'rise' ? 'true' : 'false'}
                  data-tiara-click_url={`${pathname}?type=rise`}
                >
                  친구급상승
                </a>
              </li>
            </ul>
            <div className="view_plus">
              <div className="box_plus lst" data-tiara-layer={`category_${tab}_tab`}>
                <ProfileList 
                  device={device}
                  isRankType={Boolean(tab === 'rise')}
                  profiles={profiles}
                  useRenderCount={Boolean(true)}
                  renderCount={tab === 'rise' ? 100 : profiles.size}
                  emptyMessage={tab === 'rise' ? '친구급상승 중인 프로필이 없습니다.' : ''}
                />
              </div>
              <LoadSpinner isFetching={isFetching}/>
            </div>
          </article>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state, {}) => {
  const { device, entities, portal } = state;
  const category = portal.get('category');
  return { device, entities, category };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal
  }, dispatch)
)(tiaraClickSender(ProfileCategoryPage));


// WEBPACK FOOTER //
// ./src/containers/ProfileCategoryPage/index.js